import React, {useState} from 'react';
import {Button} from 'react-bootstrap';

import {FileUploadOverlay} from "../../Files";
import {service as FileUploadService} from "../../../../Services/FileUploadService";

import {SurveyFormInputFileViewer} from "./SurveyFormInputFileViewer";
import {FileVisibilityHelper} from "../../Files/FileVisibilityHelper";
import {useFileUpload} from "../../../../Hooks/useFileUpload";
import {useSurveyFormInput} from "../../../../Hooks/SurveyFormHooks";

export const SurveyFormInputFile = (props) => {

    const {
        ConservationAction,
        SurveyTypeId,
        EditMode,
    } = props;
    
    const fileUploadId = props.Answer?.fileUploadId;
    const [fileUpload, loadUploadFile, downloadFile] = useFileUpload(fileUploadId);
    const {
        onChange,
    } = useSurveyFormInput(props);

    const inputField = React.useRef(null);

    const [uploadProgress, setUploadProgress] = useState(0);
    const [displayUpload, setDisplayUpload] = useState(false);

    const displayDialog = () => {
        inputField?.current?.click?.();
    };
    
    const onFileSelect = (e) => {
        const { files } = e?.target || {};
        
        if (files.length > 0) {
            processFile(files[0]);
        }
    };
    
    const processFile = (file) => {
        setUploadProgress(0);
        setDisplayUpload(true);
        
        FileUploadService.UploadFile(
            file.name,
            file,
            [ConservationAction.contextNodeId],
            (a, b) => {
                setUploadProgress(((a / b) * 100));
            },
            SurveyTypeId
        )
            .then(file => {
                setUploadProgress(0);
                setDisplayUpload(false);
                
                onChange?.((answer) => {
                    return {
                        ...answer,
                        fileUploadId: file.fileUploadId,
                    }
                });
            })
            .catch(_ => {
                setUploadProgress(0);
            });
    };
    
    let content = null;
    
    if (!EditMode) {
        return (
            <span>
            <SurveyFormInputFileViewer fileUpload={fileUpload} hideFileVisibilityHelper/>
        </span>
        );
    }
    
    if (displayUpload) {
        content = <FileUploadOverlay uploadingFiles={1} fileProgress={uploadProgress}/>;
    } else {
        let filename = null;
        
        if (fileUpload?.fileUploadId) {
            filename = (
                <a
                    className="link-primary"
                    onClick={_ => FileUploadService.DownloadFile(fileUpload.fileName, fileUpload.fileUploadId)}
                >
                    {fileUpload.name ?? "N/A"}
                </a>
            );
        }
        
        content = (
            <React.Fragment>
            <span className="filename">
                {filename ?? "Select A File"}
                <FileVisibilityHelper file={fileUpload?.FileUpload}/>
            </span>
                <Button
                    className="pndlm-image-upload-button pndlm-button-grey"
                    onClick={displayDialog}
                >
                    {filename ? "Replace" : "Upload"}
                </Button>
                
                <input
                    style={{ display: "none" }}
                    ref={inputField}
                    type="file"
                    onChange={onFileSelect}
                    multiple={false}
                />
            </React.Fragment>
        );
    }
    
    return <div className="sb-survey-form-input-file">{content}</div>;
}

